<template>
  <industry-single>
    <template v-slot:hero
      ><hero-full
        imageName="industries/landscaping-banner.jpg"
        altText="Landscaping worker"
      >
        <template v-slot:content>
          <h1>Landscaping Business Loans</h1>
          <p>Landscaping Business Financing & Equipment Loans</p>
        </template>
      </hero-full></template
    >
    <template v-slot:form-section>
      <FormSection>
        <template v-slot:content>
          <h2>
            <span>American Credit:</span> Empowering Landscapers everyday.
          </h2>
          <p>
            Landscaping is your passion.You’re good at what you do. After
            careful planning, you finally launch your very own business. Things
            are going great, then life happens. As a professional landscaper,
            you’re all too familiar with equipment malfunctions, seasonality
            issues affecting work consistency, and problems sometimes with
            meeting payroll. American Credit understands Landscapers, just like
            you. We help you with access to immediate funding, so you can get
            back to work asap. Read on to see how American Credit assists
            landscapers everyday with fast & simple business loans.
          </p>
        </template>
        <template v-slot:logos>
          <div class="row">
            <div class="col-12 col-md-5 order-md-2 d-flex">
              <div class="row align-items-center logos-brands">
                <div class="col-6 col-md-12">
                  <img
                    src="/static/assets/imgs/industries/nefa-logo.png"
                    alt="NEFA logo"
                  />
                </div>
                <div class="col-6 col-md-12">
                  <a
                    href="https://www.bbb.org/us/ca/palo-alto/profile/financial-services/american-credit%C2%AE-inc-1216-1079741"
                    target="_blank"
                  >
                    <img
                      src="/static/assets/imgs/industries/bbba-logo.png"
                      alt="BBBA logo"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <img
                src="/static/assets/imgs/industries/google-review.png"
                alt="Google Review"
              />
            </div>
          </div>
        </template>
        <!-- <template v-slot:form>
          <div id="form-script" class="form-script" v-once></div>
        </template> -->
      </FormSection>
    </template>
    <template v-slot:first-row>
      <RowSection
        img-side="left"
        imageName="industries/landscaping-equipment-loans.jpg"
        altText="Landscaping machine"
        backgroundPrimary="#00234D"
        backgroundSecondary="#F6F9FE"
      >
        <template v-slot:content>
          <h2>Landscaping Equipment Loans</h2>
          <p>
            As a landscaper, you require consistency in your equipment. Having
            the best landscaping equipment is a necessary investment to get the
            job done quickly & efficiently. Use your landscaping equipment loan
            to purchase riding lawn mowers, hydraulic lifts for tree trimming,
            blowers, snow plows, chippers, shredders, log splitters, pressure
            washers, trailers, trucks & more!
            <br /><br />
            American Credit understands the difficulties landscapers face. We
            work with you to understand your unique equipment needs, and then
            secure quick funding so you can get back to work.
          </p>
        </template>
      </RowSection>
    </template>
    <template v-slot:second-row>
      <RowSection
        img-side="right"
        imageName="industries/landscaping-working-capital.jpg"
        altText="Landscaping Worker"
      >
        <template v-slot:content>
          <h2>Landscaping Working Capital Solutions</h2>
          <p>
            You’ve just hit an all-time high in sales for both summer & fall.
            You then decide to scale your business to increase profits, but
            winter takes a harder toll than expected. With your savings minimal,
            you scramble for ways of keeping your employees paid and sustain
            yourself during these slow months. Access to quick working capital
            is essential as a landscaper. You need a bridge of working capital
            to maintain you and your business during tough times.
            <br /><br />
            American Credit can fix any short-term or long-term financial
            difficulties you are facing. Call us to find out what working
            capital options are available to fix any situation your landscaping
            business faces.
          </p>
        </template>
      </RowSection>
    </template>
    <template v-slot:third-row>
      <IconsGrid :gridElements="gridItems">
        <template v-slot:title>Geared to Your Needs and Your Business</template>
      </IconsGrid>
    </template>
    <template v-slot:fourth-row>
      <TablesSection :tables="tableItems">
        <template v-slot:title>Landscaping Business Loan Requirements</template>
        <template v-slot:text
          >Minimum loan requirements to expedite approval & secure quick
          funding.</template
        >
      </TablesSection>
    </template>
    <template v-slot:fifth-row>
      <RowSection
        img-side="right"
        imageName="industries/Lei-li-formal.jpeg"
        altText="photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
        class="lei-section"
      >
        <template v-slot:content>
          <h2><span>American Credit:</span> The Difference You Can Trust</h2>
          <p>
            Your business is not JUST a business. It’s YOURS. It’s your
            livelihood. It’s your passion. American Credit completely
            understands this. We help business owners just like you everyday, by
            taking a wholistic approach to business financing.
            <strong>Dr. Lei Li, PhD, CFA, & CEO of American Credit</strong>, is
            an Economist who uses his 20+ years of industry experience to help
            business owners achieve their American Dream:
            <strong>successful business ownership</strong>. <br /><br />
            Whatever financial situation you’re in, American Credit has your
            back. Apply for your business loan today!
          </p>
        </template>
        <template v-slot:button-contact>
          <contact-info
            imageName="Lei_Li.png"
            altText="Lei's photo"
            title="Call Lei"
            contactType="Service"
            phoneNumber="650-885-8055"
            class="d-none d-md-flex"
          />
        </template>
      </RowSection>
    </template>
    <template v-slot:google-reviews>
      <div class="elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"></div>
    </template>
  </industry-single>
</template>

<script>
import IndustrySingle from "../../components/layouts/IndustrySingle.vue";

import HeroFull from "../../components/industries/HeroFull.vue";
import FormSection from "../../components/industries/FormSection.vue";
import RowSection from "../../components/industries/RowSection.vue";
import IconsGrid from "../../components/industries/IconsGrid.vue";
import TablesSection from "../../components/industries/TablesSection.vue";
import ContactInfo from "../../components/industries/ContactInfo.vue";

export default {
  components: {
    IndustrySingle,
    HeroFull,
    FormSection,
    RowSection,
    IconsGrid,
    TablesSection,
    ContactInfo,
  },
  data() {
    return {
      gridItems: [
        {
          graphic: "coins.svg",
          title: "Rates starting as low as 4.5%",
          text: "Great Fixed-Interest Rates for many industries",
        },
        {
          graphic: "calendar.svg",
          title: "Terms from 12 - 84 months",
          text: "Flexible repayment terms. Choose what works best for your needs.",
        },
        {
          graphic: "cash.svg",
          title: "Loans from $10K - $10M",
          text: "Different loan amounts for business different needs.",
        },
        {
          graphic: "mobile.svg",
          title: "Fully Digital Application",
          text: "Fast & simple online application. Quick approval decision.",
        },
        {
          graphic: "house.svg",
          title: "Possible funding in just 48 hours",
          text: "Once approved, your funds are immediately sent to your bank.",
        },
        {
          graphic: "247.svg",
          title: "Apply anytime 24/7",
          text: "Apply from home anytime. Never drive to a bank again.",
        },
      ],
      tableItems: [
        {
          title: "Working Capital",
          rows: [
            {
              title: "Credit Score",
              value: "580 FICO Score",
            },
            {
              title: "Revenue",
              value: "$15K a month / $180K a year",
            },
            {
              title: "Time in Business",
              value: "1-2 years",
            },
          ],
        },
        {
          title: "Equipment Financing",
          rows: [
            {
              title: "Credit Score",
              value: "625 FICO Score",
            },
            {
              title: "Revenue",
              value: "$15K a month / $180K a year",
            },
            {
              title: "Time in Business",
              value: "1-2 years",
            },
          ],
        },
      ],
    };
  },
  computed: {
    hasSecondRow() {
      return this.$slots["second-row"];
    },
  },
  mounted() {
    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    document.title = "Loans for Landscapers | American Credit";
    meta.content =
      "Use your landscaping loan to support your business during slow seasons, and to scale up during great seasons. We assist landscapers just like you everyday!";

    let externalScriptInternetExplorer = document.createElement("script");
    externalScriptInternetExplorer.setAttribute("charset", "utf-8");
    externalScriptInternetExplorer.setAttribute("type", "text/javascript");
    externalScriptInternetExplorer.setAttribute(
      "src",
      "//js.hsforms.net/forms/v2-legacy.js"
    );
    document
      .getElementById("form-script")
      .appendChild(externalScriptInternetExplorer);

    let externalScript = document.createElement("script");
    externalScript.setAttribute("charset", "utf-8");
    externalScript.setAttribute("type", "text/javascript");
    externalScript.setAttribute("src", "//js.hsforms.net/forms/v2.js");
    document.getElementById("form-script").appendChild(externalScript);

    const formData = {
      region: "na1",
      portalId: "8349954",
      formId: "465a5b2f-3e31-414f-9f02-66349b102c60",
      target: "#form-script",
    };

    externalScript.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create(formData);
      }
    });

    externalScriptInternetExplorer.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create(formData);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 767px) {
  .logos-brands {
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// loansForLandscapers.vue?39ed88e2